<!----------------------------   Program description   ----------------------------
- Vue Name ID   : goodsOrderDtlsPopup
- Vue Name  : 주문상세 팝업
- Author      :
- Create Date : 2021.05.04
- Change History
======================================================================================
 수정일           / 이름 / 사유
======================================================================================
 YYYY.MM.DD  / XYZ / 신규
--------------------------------------------------------------------------------------->


<!-------------------------------------------------------------------------------------
- 1. template
--------------------------------------------------------------------------------------->
<template>
  <div class="layer-content" v-if="showAt">
    <div class="info2">
      주문 상세내역 입니다.
    </div>
    <div class="balance-sort-wrap mgt20">
      <div class="balance-sort-con box-type04 mgr5"
           style="width: 50%">
        <div class="__in">
          <div class="entry-cho" style="line-height: 24px;">
            <span class="label-txt">주문 정보</span>
          </div>
          <table class="tb-none">
            <colgroup>
              <col style="width:150px;">
              <col style="width:calc( 100% - 150px );">
            </colgroup>
            <tbody>
            <tr>
              <th>주문번호</th>
              <td>{{goodsOrderInfo.orderNo}}</td>
            </tr>
            <tr>
              <th>주문일자</th>
              <td>{{goodsOrderInfo.orderDe}}</td>
            </tr>
            <tr>
              <th>주문상태</th>
              <td>{{goodsOrderInfo.orderSttusNm}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="balance-sort-con box-type04 mgr5"
           style="width: 50%">
        <div class="__in">
          <div class="entry-cho" style="line-height: 24px;">
            <span class="label-txt">주문자 정보</span>
          </div>
          <table class="tb-none">
            <colgroup>
              <col style="width:150px;">
              <col style="width:calc( 100% - 150px );">
            </colgroup>
            <tbody>
            <tr>
              <th>주문자 이름</th>
              <td>{{goodsOrderInfo.mberNm}}</td>
            </tr>
            <tr>
              <th>주문자 이메일</th>
              <td>{{goodsOrderInfo.email}}</td>
            </tr>
            <tr>
              <th>주문자 전화번호</th>
              <td>{{goodsOrderInfo.cttpc}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="balance-sort-wrap mgt20"
         v-if="goodsOrderInfo.dlvyAt == 'Y'">
      <div class="balance-sort-con box-type04">
        <div class="__in">
          <div class="entry-cho" style="line-height: 24px;">
            <span class="label-txt">수령인 및 배송지 정보</span>
            <div class="f-right">
              <button class="small _bt-white"
                      v-if="chkDlvyAdresBtnEnabled"
                      @click="openGoodsOrderDlvyPopup()">
                <span>배송 정보 변경</span>
              </button>
            </div>
          </div>
          <table class="tb-none">
            <colgroup>
              <col style="width:150px;">
              <col style="width:calc( 100% - 150px );">
            </colgroup>
            <tbody>
            <tr>
              <th>수령인 이름</th>
              <td>{{goodsOrderDlvyInfo.rcverNm}}</td>
            </tr>
            <tr>
              <th>수령인 전화번호</th>
              <td>{{goodsOrderDlvyInfo.cttpc}}</td>
            </tr>
            <tr>
              <th>배송주소</th>
              <td>
                ( {{goodsOrderDlvyInfo.zip}} ) {{goodsOrderDlvyInfo.bassAdres}} {{goodsOrderDlvyInfo.detailAdres}}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="balance-sort-wrap mgt20">
      <div class="balance-sort-con box-type04 mgr5">
        <div class="__in">
          <div class="entry-cho">
          <span class="label-txt">주문 상품 정보</span>
        </div>
          <ul class="balance-sort-wrap" style="margin:-5px;flex-wrap:wrap">
            <li class="balance-sort-con"
                style="padding:5px;box-sizing: border-box;">
              <table class="tb-row">
                <colgroup>
                  <col style="width:13%;">
                  <col style="width:60%;">
                  <col style="width:27%;">
                </colgroup>
                <tbody>
                <tr v-for="(info,index) in goodsOrderDetailList"
                    :key="'goodsOrderDetail' + index" >
                  <td style="padding: 5px !important;text-align: center;">
                    <img style="border: 1px solid #efefef;width: 40px;height: 40px"
                         v-if="info.fileNo != ''"
                         :src="$onbiLib.getImageFileUrl('', info.fileNm, info.savePath, info.extsn, '')">
                    <img style="border: 1px solid #efefef;width: 40px;height: 40px"
                         v-if="info.fileNo == ''"
                         src="../../../../assets/app/images/common/i5gam-no-img.png">
                  </td>
                  <td>
                    {{ info.goodsNm }}
                    <span class="pdl10 pdr10">( 금액 : {{ $onbiLib.addComma(info.orderAmount) }}원<span class="pdl10 pdr10"> X </span>수량 : {{info.orderQy}} 개 )</span>
                  </td>
                  <td class="txt-center __right"
                      style="font-size: 18px;"
                      v-html="getGoodsOrderAmount(info)">
                  </td>
                </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="balance-sort-wrap mgt20"
         v-if="goodsOrderInfo.orderSttusCode != '102'">
      <div class="balance-sort-con box-type04">
        <div class="__in">
          <div class="entry-cho"
               style="line-height: 24px;">
            <span class="label-txt">결제 정보</span>
            <div class="f-right"
                 v-if="showRefndReqstAt">
              <button class="small _bt-white"
                      @click="openRefndReqstPopup()">
                <span>환불신청</span>
              </button>
            </div>
            <!--<div class="f-right"
                 v-if="showRefndReqstSe=='view'">
              <button class="small _bt-white"
                      @click="openRefndReqstPopup('view')">
                <span>환불 상세보기</span>
              </button>
            </div>-->
          </div>
          <template v-if="goodsOrderInfo.orderSttusCode.substring(0,1) == '1'">
            <table class="tb-row">
              <colgroup>
                <col style="width:20%;">
                <col style="width:80%;">
              </colgroup>
              <tbody>
              <tr>
                <th class="__center">
                  <span>총 결제 금액<br/>(할인포함)</span>
                </th>
                <td style="font-size: 20px;padding-left: 25px !important;">
                  {{ $onbiLib.addComma(prdctnSetleAmount) }} 원
                </td>
              </tr>
              </tbody>
            </table>
          </template>
          <template v-if="goodsOrderInfo.orderSttusCode.substring(0,1) != '1'">
            <table class="tb-row">
              <colgroup>
                <col style="width:20%;">
                <col style="width:80%;">
              </colgroup>
              <tbody>
              <tr>
                <th class="__left">
                  <span>총 결제 금액</span>
                </th>
                <td style="padding-left: 25px !important;">
                  {{ $onbiLib.addComma(goodsOrderSetleInfo.setleAmount) }} 원
                </td>
              </tr>
              <tr>
                <th class="__left">
                  <span>결제일자</span>
                </th>
                <td style="padding-left: 25px !important;">
                  {{goodsOrderSetleInfo.setleDe.substring(0, 4) + '-' +
                    goodsOrderSetleInfo.setleDe.substring(4, 6) + '-' +
                    goodsOrderSetleInfo.setleDe.substring(6, 8)}}
                </td>
              </tr>
              <tr>
                <th class="__left">
                  <span>결제 방법</span>
                </th>
                <td style="padding-left: 25px !important;">
                  {{ goodsOrderSetleInfo.setleMthNm }}
                </td>
              </tr>
              <template v-if="goodsOrderSetleInfo.setleMthCode == '101'">
                <tr>
                  <th class="__left">
                    <span>카드번호</span>
                  </th>
                  <td style="padding-left: 25px !important; line-height: 25px;">
                    {{ ifInicisSetleInfo.cardNum }}
                    <button class="mgl10 small _bt-white"
                            @click="inicisCardReceipt()">
                      <span>카드 영수증 보기</span>
                    </button>
                  </td>
                </tr>
                <tr>
                  <th class="__left">
                    <span>구매자 email</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    {{ ifInicisSetleInfo.buyeremail }}
                  </td>
                </tr>
                <tr>
                  <th class="__left">
                    <span>구매자 명</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    {{ ifInicisSetleInfo.buyername }}
                  </td>
                </tr>
                <tr>
                  <th class="__left">
                    <span>구매자 전화번호</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    {{ ifInicisSetleInfo.buyertel }}
                  </td>
                </tr>
              </template>
              <template v-if="goodsOrderSetleInfo.setleMthCode == '102'">
                <!--
                <tr>
                  <th class="__left">
                    <span>계좌주명</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    {{ ifInicisSetleInfo.acctName }}
                  </td>
                </tr>
                -->
                <tr>
                  <th class="__left">
                    <span>은행명</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    {{ ifInicisSetleInfo.acctBanknm }}
                  </td>
                </tr>
                <tr>
                  <th class="__left">
                    <span>비고</span>
                  </th>
                  <td style="padding-left: 25px !important;">
                    ※<template v-html="'&nbsp;&nbsp;'"/>입금 후 2일 이내 등록된 메일로 전자세금계산서가 발행됩니다.
                  </td>
                </tr>
              </template>
              <template v-if="goodsOrderSetleInfo.setleMthCode == '103'">
                <template v-if="goodsOrderInfo.orderSttusCode == '202'">
                  <tr>
                    <th class="__left">
                      <span>예금주명</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.vactName }}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>입금은행명</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.vactbankname }}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>입금계좌번호</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.vactNum }}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>입금기한</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.vactDate.substring(0,4) + '-' +
                    ifInicisSetleInfo.vactDate.substring(4,6) + '-' +
                    ifInicisSetleInfo.vactDate.substring(6,8) + ' 까지' }}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>비고</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      ※<template v-html="'&nbsp;&nbsp;'"/>입금기한이 지날 경우 자동으로 결제가 취소됩니다.
                    </td>
                  </tr>
                </template>
                <template v-if="goodsOrderInfo.orderSttusCode != '202'">
                  <tr>
                    <th class="__left">
                      <span>송금자명</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.vactInputname }}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>송금일시</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      {{ ifInicisSetleInfo.dtTrans.substring(0,4) + '-' +
                    ifInicisSetleInfo.dtTrans.substring(4,6) + '-' +
                    ifInicisSetleInfo.dtTrans.substring(6,8) + ' ' +
                    ifInicisSetleInfo.tmTrans.substring(0, 2) + ':' +
                    ifInicisSetleInfo.tmTrans.substring(2, 4) + ':' +
                    ifInicisSetleInfo.tmTrans.substring(4, 6)}}
                    </td>
                  </tr>
                  <tr>
                    <th class="__left">
                      <span>비고</span>
                    </th>
                    <td style="padding-left: 25px !important;">
                      ※<template v-html="'&nbsp;&nbsp;'"/>입금 후 2일 이내 등록된 메일로 전자세금계산서가 발행됩니다.
                    </td>
                  </tr>
                </template>
              </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
    <div class="balance-sort-wrap mgt20"
         v-if="refndReqstInfo != null">
      <div class="balance-sort-con box-type04 mgr5">
        <div class="__in">
          <div class="entry-cho">
            <span class="label-txt">환불 정보</span>
          </div>
          <ul class="balance-sort-wrap" style="margin:-5px;flex-wrap:wrap">
            <li class="balance-sort-con"
                style="padding:5px;box-sizing: border-box;">
              <table class="tb-row">
                <colgroup>
                  <col style="width:20%;">
                  <col style="width:80%;">
                </colgroup>
                <tbody>
                <tr>
                  <th>청구항목</th>
                  <td>
                    <template v-if="goodsOrderDetailList.length == 1">
                      {{goodsOrderDetailList[0].goodsNm}}
                    </template>
                    <template v-if="goodsOrderDetailList.length > 1">
                      {{goodsOrderDetailList[0].goodsNm + ' [ 외 ' + (goodsOrderDetailList.length-1) + '건 ]'}}
                    </template>
                  </td>
                </tr>
                <!--환불 완료되지 않은 경우-->
                <template v-if="refndReqstInfo.refndSttusCode.substr(0, 1) != '2'">
                  <tr>
                    <th>상태</th>
                    <td>{{refndReqstInfo.refndSttusNm}} [ {{refndReqstInfo.registDt}} ]</td>
                  </tr>
                  <tr>
                    <th>결제방법</th>
                    <td>{{refndReqstInfo.setleMthNm}}</td>
                  </tr>
                  <tr>
                    <th>금액</th>
                    <td>{{$onbiLib.addComma(refndReqstInfo.setleAmount)}}원</td>
                  </tr>
                </template>
                <!--환불 완료된 경우-->
                <template v-if="refndReqstInfo.refndSttusCode.substr(0, 1) == '2'">
                  <tr>
                    <th>상태</th>
                    <td>{{refndReqstInfo.refndSttusNm}} [ {{refndReqstInfo.refndRegistDt}} ]</td>
                  </tr>
                  <tr>
                    <th>환불방법</th>
                    <td>{{refndReqstInfo.refndMthNm}}</td>
                  </tr>
                  <tr>
                    <th>금액</th>
                    <td>{{$onbiLib.addComma(refndReqstInfo.refndAmount)}}원</td>
                  </tr>
                </template>
                <tr>
                  <th>예금주명</th>
                  <td>{{refndReqstInfo.dpstr}}</td>
                </tr>
                <tr>
                  <th>환불계좌</th>
                  <td>[ {{refndReqstInfo.bankNm}} ]  {{refndReqstInfo.acnutno}}</td>
                </tr>
                <tr>
                  <th>사유</th>
                  <td>{{refndReqstInfo.refndMemo}}</td>
                </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="btn-wrap t-line center" style="border-top:0;">
      <button class="big _bt-white"
              @click="closePopup()">
        <span>확인</span>
      </button>
      <button class="big _bt-navy"
              v-if="goodsOrderInfo.orderSttusCode == '101' || goodsOrderInfo.orderSttusCode == '199'"
              @click="goodsOrderSetleClick()">
        <span>결제하기</span>
      </button>
    </div>
  </div>
</template>

<!-------------------------------------------------------------------------------------
- 2. Script
--------------------------------------------------------------------------------------->
<script>
/*======================================================================================*
 * 2.1. Import
 *======================================================================================*/
export default {
  /*======================================================================================*
   * 2.2. 뷰 컴포넌트 명칭
   *======================================================================================*/
  nm: 'goodsOrderDtlsPopup',
  props: ['param'],
  /*======================================================================================*
   * 2.3. 지역 변수
   *======================================================================================*/
  data: function () {
    return {
      showAt: false,
      goodsOrderInfo:{},
      goodsOrderDetailList:new Array(),
      goodsOrderDlvyInfo:{},
      goodsOrderSetleInfo:{},
      ifInicisSetleInfo:{},
      refndReqstInfo: {},
    }
  },
  computed : {
    mberInfo : function(){
      return this.$store.getters.getMberInfo;
    },
    dayInfo: function(){
      return this.$store.getters.getDayInfo;
    },
    chkDlvyAdresBtnEnabled: function(){ //주문완료, 입금대기중, 결제완료인 경우에만 변경 가능
      let showAt = false;
      if(this.goodsOrderInfo.orderSttusCode == '101'
          || this.goodsOrderInfo.orderSttusCode == '201'
          || this.goodsOrderInfo.orderSttusCode == '202'){
        showAt = true;
      }

      return showAt;
    },
    showRefndReqstAt: function(){
      let showAt = false;

      if(this.refndReqstInfo == null){  //환불 신청한 내역X
        if(this.goodsOrderInfo.orderSttusCode == '201'
            || this.goodsOrderInfo.orderSttusCode == '301'
            || this.goodsOrderInfo.orderSttusCode == '302'){  //결제완료, 발송준비중, 발송완료인 경우
          if(this.goodsOrderSetleInfo.setleAmount != '0'){  //결제 금액이 0원인 경우는 환불X
            showAt = true;
          }
        }
      }

      return showAt;
    },
    prdctnSetleAmount: function(){
      let amount = 0;

      //localhost:9081은 나중에 삭제!!
      if(location.host.indexOf('i5gam.gulumma.net') > -1 || location.host.indexOf('localhost:8081') > -1){
        this.goodsOrderDetailList.forEach(function(info){
          amount += (info.orderAmount*info.orderQy)-info.dscntAmount;
        });
      }else{
        amount = 1000;
      }

      return amount;
    }
  },
  /*======================================================================================*
   * 2.3. 함수 (일반 함수, 사용자 정의 함수, 이벤트 함수)
   *======================================================================================*/
  methods: {
    init: function () {
      this.searchGoodsOrderInfo();
    },
    searchGoodsOrderInfo: function(){
      this.axios.post('/i5gam/goods/searchGoodsOrderInfo.act',{
        orderNo: this.param.orderNo
      }).then(function(response) {
        const goodsInfo = response.data.goodsInfo;

        this.goodsOrderInfo = goodsInfo.goodsOrderInfo;
        this.goodsOrderDetailList = goodsInfo.goodsOrderDetailList;
        this.goodsOrderDlvyInfo   = goodsInfo.goodsOrderDlvyInfo;
        this.goodsOrderSetleInfo  = goodsInfo.goodsOrderSetleInfo;
        this.ifInicisSetleInfo    = goodsInfo.ifInicisSetleInfo;
        this.refndReqstInfo    = goodsInfo.refndReqstInfo;

        //배송비 존재하는 경우 주문상세에 배송비 정보 넣어줌. goodsNo는 임의로 999로 셋팅함.
        let dlvyAmount = this.goodsOrderInfo.dlvyAmount;
        if(dlvyAmount > 0){
          this.goodsOrderDetailList.push({goodsNo: '999', goodsNm: '배송비', orderAmount: dlvyAmount, orderQy: 1, dscntAmount: 0, fileNo: '',});
        }

        this.showAt = true;
      }.bind(this)).catch(function(e) {
        console.log(e);
        this.$toasted.show(this.$onbiLib.msg.err.system);
      }.bind(this));
    },
    goodsOrderSetleClick: function(){
      this.closePopup();

      const popupInfo = {
        se:'modal',
        id:'goodsOrderSetlePopup',
        wid:'820',
        hei:'',
        tit:'결제',
        draggableAt:false,
        param: {
          orderNo: this.goodsOrderInfo.orderNo,
          setleCallbackFunc: this.param.setleCallbackFunc,
        }
      }

      this.$store.commit('openPopup',popupInfo);
    },
    openGoodsOrderDlvyPopup: function(){
      const popupInfo = {
        se:'modal',
        id:'goodsOrderDlvyInfoPopup',
        wid:'750',
        hei:'',
        tit:'배송정보 변경',
        draggableAt:false,
        param: {
          orderNo: this.goodsOrderDlvyInfo.orderNo,
          dlvyNo: this.goodsOrderDlvyInfo.dlvyNo,
          rcverNm: this.goodsOrderDlvyInfo.rcverNm,
          cttpc: this.goodsOrderDlvyInfo.cttpc,
          zip: this.goodsOrderDlvyInfo.zip,
          bassAdres: this.goodsOrderDlvyInfo.bassAdres,
          detailAdres: this.goodsOrderDlvyInfo.detailAdres,
          dlvyAmount: this.goodsOrderInfo.dlvyAmount,
          callBackFunc: this.searchGoodsOrderInfo
        }
      };

      this.$store.commit('openPopup',popupInfo);
    },
    openRefndReqstPopup: function(){
      let goodsNm = '';

      if(this.goodsOrderDetailList.length == 1){
        goodsNm = this.goodsOrderDetailList[0].goodsNm;
      }else{
        goodsNm = this.goodsOrderDetailList[0].goodsNm + ' [ 외 ' + (this.goodsOrderDetailList.length-1) + '건 ]';
      }

      let param = {
        //se: se,
        fcltcd: this.goodsOrderInfo.fcltcd,
        fcltNm: this.goodsOrderInfo.fcltNm,
        goodsOrderSetleInfo: this.goodsOrderSetleInfo,
        refndReqstInfo: this.refndReqstInfo,
        goodsNm : goodsNm,
        callbackFunc: this.searchGoodsOrderInfo,
      };

      const popupInfo = {
        se:'modal',
        id:'refndReqstPopup',
        wid:'650',
        hei:'',
        tit:'환불신청 - 주문번호 ' + this.goodsOrderInfo.orderNo + '번',
        draggableAt:false,
        param: param,
      };

      this.$store.commit('openPopup',popupInfo);
    },
    inicisCardReceipt: function(){
      const url = 'https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid='+this.ifInicisSetleInfo.tid+'&noMethod=1';
      const name = '카드영수증';
      const option = 'width=420, height=750';
      window.open(url,name,option);
    },
    getGoodsOrderAmount: function(info){
      let amount = '';

      if(typeof info.dscntAmount == 'undefined' || info.dscntAmount == '') info.dscntAmount = 0;

      if(Number(info.dscntAmount) > 0) {
        amount += '<span style="text-decoration: line-through; color: red; font-size: 15px;">'
        amount += this.$onbiLib.addComma(this.getGoodsSumAmount(info.orderAmount, info.orderQy)) + '원</span><br/>';
      }

      amount += '<span>' + this.$onbiLib.addComma(this.getDscntGoodsAmount(info)) + '원</span>';

      return amount;
    },
    getGoodsSumAmount: function(orderAmount,orderQy){
      return orderAmount * orderQy;
    },
    getDscntGoodsAmount: function(info){
      return (info.orderAmount * info.orderQy) - info.dscntAmount;
    },
    closePopup: function(){
      this.$store.commit('closePopup');
    }
  },
  /*======================================================================================*
   * 2.4. Vue Life Cycle
   *======================================================================================*/
  mounted: function () {
    this.init();
  }
}
</script>
<!-------------------------------------------------------------------------------------
- 3. 뷰 스타일 block
--------------------------------------------------------------------------------------->
<style scoped>
</style>